module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/coffee-2-da2378b44fa6f1ccd2259d16b69b3781.svg";